import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from 'apexcharts';

interface LineChartProps {
  options: ApexOptions;
  series?: any;
  height?: string;
}
const chartTitleStyle = {
  fontFamily: "var(--font-subheading)",
  fontWeight: "700",
};

const LineChart = ({options, series, height='100%'} : LineChartProps) => {
  const markerOptions = options.markers || {};
  const markerStrokeColors = Array.isArray(options.colors) && options.colors.length
    ? options.colors
    : markerOptions.strokeColors || '#11183f';

  const chartOptions: ApexOptions = {
    ...options,
    title: {
      ...options.title,
      margin: 18,
      style: {
        ...chartTitleStyle,
        ...options.title?.style,
      },
    },
    legend: {
      ...options.legend,
      offsetY:
        typeof options.legend?.offsetY === "number" && options.legend.offsetY > 0
          ? options.legend.offsetY
          : 8,
    },
    markers: {
      ...markerOptions,
      size: !markerOptions.size || markerOptions.size < 4 ? 4 : markerOptions.size,
      colors: markerOptions.colors || ['#fff'],
      strokeColors: markerStrokeColors,
      strokeWidth: !markerOptions.strokeWidth || markerOptions.strokeWidth < 3 ? 3 : markerOptions.strokeWidth,
      strokeOpacity: 1,
      hover: {
        size: 6,
        ...markerOptions.hover,
      },
    },
  };

  return (
      <div className="pricing-matrix-line-chart">
        <ApexCharts options={chartOptions} series={series} height={height} />
      </div>
  );
};

export default LineChart;
